import React from 'react';

export interface MentionCandidate {
  id: string;
  name: string;
}

interface Props {
  candidates: MentionCandidate[];
  activeIdx: number;
  onPick: (candidate: MentionCandidate) => void;
  onHover: (idx: number) => void;
  /** Position absolue de la popup (top en px, depuis le bas du textarea — on
   *  remontera la popup au-dessus via translateY(-100%)). */
  anchorTop: number;
  anchorLeft: number;
}

const MentionPopover: React.FC<Props> = ({ candidates, activeIdx, onPick, onHover, anchorTop, anchorLeft }) => {
  if (candidates.length === 0) return null;
  return (
    <div
      className="absolute z-50 min-w-[200px] max-w-[300px] max-h-[240px] overflow-y-auto rounded-xl border border-slate-200 dark:border-[rgba(100,140,210,0.3)] bg-white dark:bg-[rgba(15,30,60,0.97)] backdrop-blur shadow-2xl"
      style={{ top: anchorTop, left: anchorLeft, transform: 'translateY(-100%)' }}
      // Empêche le textarea de perdre le focus quand on clique dans la popup
      onMouseDown={e => e.preventDefault()}
    >
      <div className="px-3 py-1.5 text-[10px] font-bold text-slate-400 dark:text-[#546a96] uppercase tracking-widest border-b border-slate-100 dark:border-[rgba(100,140,210,0.15)]">
        Mentionner
      </div>
      {candidates.map((c, i) => (
        <button
          key={c.id}
          type="button"
          onMouseEnter={() => onHover(i)}
          onClick={() => onPick(c)}
          className={`w-full text-left px-3 py-2 text-sm transition-colors flex items-center gap-2 ${
            i === activeIdx
              ? 'bg-cyan-100 dark:bg-cyan-500/20 text-slate-900 dark:text-[#e0eaff]'
              : 'text-slate-700 dark:text-[#a5b8d8] hover:bg-slate-50 dark:hover:bg-[rgba(100,140,210,0.1)]'
          }`}
        >
          <span className="w-6 h-6 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 text-white text-[10px] font-black flex items-center justify-center flex-shrink-0">
            {c.name.charAt(0).toUpperCase()}
          </span>
          <span className="truncate">{c.name}</span>
        </button>
      ))}
    </div>
  );
};

export default MentionPopover;
